// Playing area bookings, the MEMBER and PUBLIC side (BOOKINGS_PLAN.md §4):
// the availability grid, quotes and bookings, my bookings, and the visitor
// pages that need no login. Kept apart from network/endpoints.js so the admin
// booking pages (their own constants) and these can grow side by side.
const query = (params) => {
  const q = Object.entries(params ?? {})
      .filter(([, v]) => v != null && v !== '')
      .map(([k, v]) => k + '=' + encodeURIComponent(v));
  return q.length ? '?' + q.join('&') : '';
};

export const bookingsMemberEndpoints = {
  /** Anyone may read the grid; a signed-in viewer gets their own labels and allowance. */
  availability: (clubId, {from = null, days = null, sportId = null} = {}) => ({
    path: '/api/v2/bookings/clubs/' + clubId + '/availability' + query({from, days, sportId}),
    method: 'get', requiresAuth: false, optionalAuth: true,
  }),
  quote: {path: '/api/v2/bookings/quote', method: 'post', requiresAuth: true},
  create: {path: '/api/v2/bookings', method: 'post', requiresAuth: true},
  mine: ({clubId = null, includePast = false} = {}) => ({
    path: '/api/v2/bookings/mine' + query({clubId, includePast: includePast ? 'true' : null}),
    method: 'get', requiresAuth: true,
  }),
  get: (id) => ({path: '/api/v2/bookings/' + id, method: 'get', requiresAuth: true}),
  cancel: (id) => ({path: '/api/v2/bookings/' + id + '/cancel', method: 'post', requiresAuth: true}),
  release: (id) => ({path: '/api/v2/bookings/' + id + '/release', method: 'post', requiresAuth: true}),
  pay: (id) => ({path: '/api/v2/bookings/' + id + '/pay', method: 'post', requiresAuth: true}),
  paySync: (id) => ({path: '/api/v2/bookings/' + id + '/pay/sync', method: 'post', requiresAuth: true}),

  /** The club page, for the club's id, slug and name (works signed out). */
  clubPage: (idOrSlug) => ({path: '/api/v2/page/club/' + idOrSlug, method: 'get', requiresAuth: false, optionalAuth: true}),

  // Visitors (B10, BE4, SE19): no login, the token is the authorisation.
  publicPage: (slug, returnUrl = null) => ({
    path: '/api/v2/public/clubs/' + slug + '/booking' + query({returnUrl}), method: 'get', requiresAuth: false,
  }),
  visitorStart: (slug) => ({path: '/api/v2/public/clubs/' + slug + '/bookings', method: 'post', requiresAuth: false}),
  visitorGet: (token, returnUrl = null) => ({
    path: '/api/v2/public/bookings/' + token + query({returnUrl}), method: 'get', requiresAuth: false,
  }),
  visitorConfirm: (token) => ({path: '/api/v2/public/bookings/' + token + '/confirm', method: 'post', requiresAuth: false}),
  visitorPay: (token) => ({path: '/api/v2/public/bookings/' + token + '/pay', method: 'post', requiresAuth: false}),
  visitorPaySync: (token) => ({path: '/api/v2/public/bookings/' + token + '/pay/sync', method: 'post', requiresAuth: false}),
  visitorCancel: (token) => ({path: '/api/v2/public/bookings/' + token + '/cancel', method: 'post', requiresAuth: false}),
};
